<details-section
  [title]="'simulationBuilder.SIM_DETAILS_SECTION_TITLE' | transloco"
  [showDetails]="true"
  [detailsText]="'simulationBuilder.WHAT_USERS_SEE_PREVIEW_DETAILS_CTA' | transloco"
  (actionClicked)="previewModal()"
  [actiondisabled]="previewModalButtonState"
  [description]="simulationDetailsSectionDescription"
>

  <div class="container" [formGroup]="form">
    <div class="container" formArrayName="simulationDetailtabs">
      <div
        *ngFor="let tab of simulationDetailtabs.controls; let i = index"
        [formGroupName]="i"
      >
        <qai-field [label]="tab.get('tabTitle')?.value">
          <textarea
            qai-textarea
            autosize
            [maxLines]="30"
            qaiTrimLeading
            qaiPasteClean
            formControlName="tabText"
          ></textarea>
        </qai-field>
      </div>
    </div>

    <qai-field [label]="'simulationBuilder.SIM_ADDITIONAL_SECTION_TITLE_LABEL' | transloco">
      <input qai-input type="text" qaiTrimLeading formControlName="additionalSectionTitle" />
    </qai-field>

    <qai-field [label]="'simulationBuilder.SIM_ADDITIONAL_SECTION_INFO_LABEL' | transloco">
      <textarea
        qai-textarea
        autosize
        [maxLines]="30"
        qaiTrimLeading
        qaiPasteClean
        formControlName="additionalSectionInfo"
      ></textarea>
    </qai-field>
  </div>
</details-section>


<preview-simulations-details-modal
  [open]="openPreviewModal"
  [tabs]="previewTabs"
  (closeModal)="handleModalClose()"
></preview-simulations-details-modal>
